export function sampleAnchorCurve(anchors, options = {}) {
  const {
    style = "smooth",
    samplesPerSegment = 24,
    color = "#ff9800",
    width = 6,
    openStart = false,
    openEnd = false,
    openMarkerGap = 0,
  } = options;

  const x = [];
  const y = [];

  for (let index = 0; index < anchors.length - 1; index += 1) {
    const start = anchors[index];
    const end = anchors[index + 1];
    const quadraticBend = Math.random() < 0.5 ? "start" : "end";

    for (let sample = index === 0 ? 0 : 1; sample <= samplesPerSegment; sample += 1) {
      const t = sample / samplesPerSegment;
      const progress =
        style === "line"
          ? t
          : style === "turning"
          ? t * t * (3 - 2 * t)
          : quadraticBend === "start"
          ? t * t
          : 1 - (1 - t) * (1 - t);

      x.push(start.x + (end.x - start.x) * t);
      y.push(start.y + (end.y - start.y) * progress);
    }
  }

  const trimOpenEndpoint = (fromStart) => {
    if (openMarkerGap <= 0) return;

    const anchor = fromStart ? anchors[0] : anchors[anchors.length - 1];
    const neighbourIndex = fromStart ? 1 : x.length - 2;
    const dx = x[neighbourIndex] - anchor.x;
    const dy = y[neighbourIndex] - anchor.y;
    const distance = Math.hypot(dx, dy);
    if (distance <= 0) return;

    const scale = Math.min(openMarkerGap / distance, 0.9);
    const trimmedX = anchor.x + dx * scale;
    const trimmedY = anchor.y + dy * scale;

    if (fromStart) {
      x[0] = trimmedX;
      y[0] = trimmedY;
    } else {
      x[x.length - 1] = trimmedX;
      y[y.length - 1] = trimmedY;
    }
  };

  if (openStart) trimOpenEndpoint(true);
  if (openEnd) trimOpenEndpoint(false);

  return { x, y, color, width };
}

export function pickCurveStyle() {
  return Math.random() < 0.28 ? "line" : "smooth";
}

export function samplePolynomialCurve(fn, xL, xR, importantXs = [], options = {}) {
  const { step = 0.05, color = "orange", width = 6 } = options;
  const xs = [];

  for (let x = xL; x <= xR + 1e-9; x += step) {
    xs.push(Number(x.toFixed(6)));
  }
  importantXs.forEach((x) => xs.push(x));

  const uniqueXs = Array.from(new Set(xs)).sort((a, b) => a - b);
  return {
    x: uniqueXs,
    y: uniqueXs.map((x) => fn(x)),
    color,
    width,
  };
}
